import { useEffect, useState } from 'react';
import { R, ft, label, shadow } from '../lib/ui';
import { api } from '../lib/api';

export function Login() {
  const [tab, setTab] = useState<'discord' | 'password'>('discord');
  const [code, setCode] = useState('');
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const err = params.get('error');
    if (err) {
      setError(
        err === 'invalid_token'
          ? 'Ссылка для входа недействительна или срок её действия истёк. Получите новую команду /войти в Discord.'
          : decodeURIComponent(err),
      );
    }
  }, []);

  const handleDiscordSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const cleanCode = code.replace(/\s+/g, '').trim();
      if (!cleanCode) {
        throw new Error('Введите 6-значный код из Discord бота');
      }
      if (cleanCode.length < 6) {
        throw new Error('Код должен состоять из 6 цифр');
      }
      await api.authLoginCode({ code: cleanCode });
      window.location.href = '/';
    } catch (err: any) {
      setError(err.message || 'Ошибка входа по коду');
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (!login.trim() || !password.trim()) {
        throw new Error('Заполните логин и пароль');
      }
      await api.authLogin({ login, password });
      window.location.href = '/';
    } catch (err: any) {
      setError(err.message || 'Ошибка авторизации');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: R.bg,
        padding: 20,
      }}
    >
      <div
        style={{
          maxWidth: 440,
          width: '100%',
          background: R.bgPanel,
          border: ft.strong,
          boxShadow: shadow.panel,
          padding: '32px 28px 26px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
        }}
      >
        <img
          src="/favicon.png"
          alt=""
          style={{ width: 48, height: 48, display: 'block', marginBottom: 20 }}
        />

        <div style={label}>GTA5RP · GOV</div>

        <h1
          style={{
            fontSize: 28,
            fontWeight: 800,
            letterSpacing: '-.015em',
            margin: '2px 0 6px',
            color: R.text,
          }}
        >
          Redwood Tables
        </h1>

        <p
          style={{
            fontSize: 13,
            color: R.textMuted,
            marginBottom: 20,
            lineHeight: 1.5,
          }}
        >
          Войдите, чтобы работать с таблицами, премиями и реестрами.
        </p>

        {/* Переключатель вкладок: Discord (одноразовый код) / Логин и пароль */}
        <div
          style={{
            display: 'flex',
            borderBottom: ft.strong,
            marginBottom: 20,
            gap: 8,
          }}
        >
          <button
            type="button"
            onClick={() => {
              setTab('discord');
              setError('');
            }}
            style={{
              padding: '8px 14px',
              background: 'transparent',
              border: 'none',
              borderBottom: `2px solid ${tab === 'discord' ? R.accent : 'transparent'}`,
              color: tab === 'discord' ? R.text : R.textMuted,
              fontWeight: tab === 'discord' ? 700 : 500,
              fontSize: 13,
              cursor: 'pointer',
              marginBottom: -1,
            }}
          >
            Вход через Discord
          </button>
          <button
            type="button"
            onClick={() => {
              setTab('password');
              setError('');
            }}
            style={{
              padding: '8px 14px',
              background: 'transparent',
              border: 'none',
              borderBottom: `2px solid ${tab === 'password' ? R.accent : 'transparent'}`,
              color: tab === 'password' ? R.text : R.textMuted,
              fontWeight: tab === 'password' ? 700 : 500,
              fontSize: 13,
              cursor: 'pointer',
              marginBottom: -1,
            }}
          >
            Логин и пароль
          </button>
        </div>

        {error && (
          <p
            style={{
              fontSize: 12.5,
              color: R.danger,
              marginBottom: 16,
              lineHeight: 1.45,
              padding: '10px 12px',
              border: `1px solid ${R.dangerBorder}`,
              background: R.dangerSubtle,
            }}
          >
            {error}
          </p>
        )}

        {tab === 'discord' ? (
          <form onSubmit={handleDiscordSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
            <div
              style={{
                padding: '12px 14px',
                background: R.accentSubtle,
                border: `1px solid ${R.accent}33`,
                borderRadius: 4,
                marginBottom: 16,
                fontSize: 12.5,
                lineHeight: 1.5,
                color: R.text,
              }}
            >
              <div>
                <strong>Как войти:</strong>
              </div>
              <div style={{ marginTop: 4 }}>
                1. Напишите команду <code>/войти</code> боту на сервере Discord.
              </div>
              <div style={{ marginTop: 2 }}>
                2. Бот пришлёт вам <strong>ссылку в 1 клик</strong> или <strong>6-значный код</strong>:
              </div>
            </div>

            <label
              style={{
                fontSize: 12,
                color: R.textMuted,
                marginBottom: 6,
                fontWeight: 600,
              }}
            >
              Одноразовый 6-значный код:
            </label>
            <input
              type="text"
              placeholder="123 456"
              value={code}
              maxLength={7}
              onChange={(e) => setCode(e.target.value)}
              style={{
                height: 48,
                padding: '0 14px',
                marginBottom: 16,
                background: R.bg,
                border: ft.strong,
                color: R.text,
                fontSize: 22,
                fontWeight: 800,
                letterSpacing: '0.25em',
                textAlign: 'center',
                boxSizing: 'border-box',
              }}
            />

            <button
              type="submit"
              disabled={loading || !code.trim()}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: 42,
                padding: '0 16px',
                background: R.accent,
                color: '#fff',
                fontSize: 14,
                fontWeight: 800,
                border: 'none',
                cursor: loading || !code.trim() ? 'not-allowed' : 'pointer',
                opacity: loading || !code.trim() ? 0.6 : 1,
              }}
            >
              {loading ? 'Проверяем…' : 'Войти по коду'}
            </button>

            <div
              style={{
                marginTop: 14,
                textAlign: 'center',
                fontSize: 11.5,
                color: R.textMuted,
                lineHeight: 1.4,
              }}
            >
              💡 Либо просто нажмите кнопку в сообщении бота — и откроется уже авторизованный аккаунт!
            </div>
          </form>
        ) : (
          <form onSubmit={handlePasswordSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
            <input
              type="text"
              placeholder="Логин"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              style={{
                height: 40,
                padding: '0 12px',
                marginBottom: 12,
                background: R.bg,
                border: ft.strong,
                color: R.text,
                fontSize: 14,
                boxSizing: 'border-box',
              }}
            />

            <input
              type="password"
              placeholder="Пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{
                height: 40,
                padding: '0 12px',
                marginBottom: 20,
                background: R.bg,
                border: ft.strong,
                color: R.text,
                fontSize: 14,
                boxSizing: 'border-box',
              }}
            />

            <button
              type="submit"
              disabled={loading}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: 42,
                padding: '0 16px',
                background: R.accent,
                color: '#fff',
                fontSize: 14,
                fontWeight: 800,
                border: 'none',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1,
              }}
            >
              {loading ? 'Входим…' : 'Войти'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

/** Вошёл, но разделов ему пока не открыли. */
export function NoAccess() {
  return (
    <div
      style={{
        flex: 1,
        display: 'grid',
        placeItems: 'center',
        padding: 40,
        color: R.textMuted,
        fontSize: 13,
        textAlign: 'center',
      }}
    >
      <span style={{ maxWidth: 460, lineHeight: 1.5 }}>
        Вы вошли, но администратор ещё не открыл вам ни одного раздела.
      </span>
    </div>
  );
}
